<app-loader [loading]="isLoading" [fullPage]="true" [title]="'chargement'"></app-loader>
<section *ngIf="!isLoading" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="currentStepId"></app-stepper-component>
    <div class="simulation__group">
        <div>
            <h1 class="page-title page-title--primary">
                {{ 'documentselection.header.title' | i18n }}
            </h1>
            <section class="loading-page">
                <div class="simulation__group loading-page--success">
                    <p class="page-subtitle page-subtitle--uppercase page-subtitle--primary">
                        {{ 'signature.afterSuccess.subtitle' | i18n }}
                    </p>
                    <p class="signature__message-container signature__message--success">
                        <span class="icon--checkmark"></span>
                        <span>
                            {{ 'signature.afterSuccess.message' | i18n }}
                        </span>
                    </p>
                    <p class="signature__message-container">
                        <span class="icon--info-2"></span>
                        <span>
                            {{ 'signature.afterSuccess.generalInfo' | i18n }}
                        </span>
                    </p>
                </div>
                <div class="simulation__buttons simulation__buttons--signature">
                    <div class="grid-mobile-2 no-gutter">
                        <button type="button" class="button--previous-accueil" (click)="goBackToEspaceClientModal = true">
                            {{ 'signature.button.home' | i18n }}
                        </button>
                    </div>
                    <button
                        type="button"
                        id="navigateToFinalisation"
                        class="button button--primary button--next float-right button--centered-mobile"
                        data-tag-commander=""
                        [appTagCommander]="'tagCo.signature.continue.button'"
                        (click)="navigateToNextStep()"
                    >
                        {{ 'signature.button.next' | i18n }}
                    </button>
                </div>
            </section>
        </div>
    </div>
</section>
<app-validation-modal-component
    [modalTitle]="'adhesion.backToDashboard.modal.title'"
    [content]="'adhesion.backToDashboard.modal.body'"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    [showInfoIcon]="false"
    [visibility]="goBackToEspaceClientModal"
    (crossClick)="goBackToEspaceClientModal = false"
    (leftClick)="goBackToEspaceClientModal = false"
    (rightClick)="navigateToEspaceClient()"
></app-validation-modal-component>
